import { Directive, ElementRef, HostListener, Output, EventEmitter, Injectable } from '@angular/core';


@Directive({
  
  selector: '[appOutsideClick]',
  standalone:true,
})
export class OutsideClickDirective {
  @Output()
  appOutsideClick = new EventEmitter();


  constructor(private _elementRef: ElementRef) {
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: any) {
    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.appOutsideClick.emit(true);
    } else {
      this.appOutsideClick.emit(false);
    }
  }

}